var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustedShopStar = function SvgTrustedShopStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.623 0 8.115 7.637 0 7.64l6.566 4.72L4.06 20l6.562-4.72L17.191 20l-2.507-7.64 6.566-4.72-8.115-.003z",
    clipRule: "evenodd"
  })));
};
export { SvgTrustedShopStar as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMiAyMCI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC42MjMgMCA4LjExNSA3LjYzNyAwIDcuNjRsNi41NjYgNC43Mkw0LjA2IDIwbDYuNTYyLTQuNzJMMTcuMTkxIDIwbC0yLjUwNy03LjY0IDYuNTY2LTQuNzItOC4xMTUtLjAwM0wxMC42MjMgMFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPgo=";